export default __webpack_public_path__ + "static/logo-74929f92cead79160a18846cfc0e703b.png";